export const manageTeacherSubscriptionsIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '.tool-header',
    intro: 'Teacher Subscriptions is where you can manage System Subscriptions for the school.',
  },
  {
    element: '#diagnostic-subscriptions',
    intro: 'See the number of total Diagnostic subscriptions for the school. Also see the number of unassigned subscriptions, '
      + 'subscriptions granted to teachers, subscriptions assigned to students who haven’t started, and subscriptions that have been consumed.',
  },
  {
    element: '#system-subscriptions',
    intro: 'See the number of total System subscriptions for the school. Also see the number of unassigned subscriptions, '
      + 'subscriptions granted to teachers, subscriptions assigned to students who haven’t started, and subscriptions that have been consumed.',
  },
  {
    element: '.report-table tbody tr:first-child',
    intro: 'Adjust the number of subscriptions assigned to a teacher by typing a number in the box under System.',
  },
  {
    element: '.save-button',
    intro: 'Click save to apply the subscription movements you made.',
  }
];
